import { useForm, useWatch } from "react-hook-form";
import { UploadInformationForm } from "../upload/UploadInformation";
import { useEffect } from "react";
import { useFileContext } from "../context/FileWrapper";

const UploadInformationStandaloneForm = ({ file, estateId }) => {
  const { updateFileInformation, addAssociation } = useFileContext();

  const { control } = useForm({
    defaultValues: {
      name: file.name,
      documentType: file.documentType,
      effectiveDate: file.effectiveDate,
    },
  });

  const name = useWatch({ control, name: "name" });
  const documentType = useWatch({ control, name: "documentType" });
  const effectiveDate = useWatch({ control, name: "effectiveDate" });

  useEffect(() => {
    addAssociation(file.uuid, [{ id: estateId }]);
  }, []);

  useEffect(() => {
    updateFileInformation(file.uuid, {
      name,
      documentType,
      effectiveDate,
    });
  }, [name, documentType, effectiveDate]);

  return <UploadInformationForm control={control} isModalView />;
};

export default UploadInformationStandaloneForm;
